  export default [
    {
      id: 'RETURN',
      description: 'Reversa',
    },
    {
      id: 'NORMAL',
      description: 'Normal',
    },
  ];



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/quoting-return/enum/EnumReturnAPIType.js